// extracted by mini-css-extract-plugin
export default {"flex":"SearchResultsEmpty_flex__Pg-Ft","noResultMessage":"SearchResultsEmpty_noResultMessage__arO2M"};